import Filter from 'Pages/Filter';
import PasswordManagement from 'Pages/PasswordManagement/PasswordManagement';
import ViewAll from './ViewAll';
import Search from './Search';
import TvGuide from './TvGuide';
import Login from './Login';
import Logout from './Logout';
import Details from './Details';
import Register from './Register';
import Player from '../../localGluons/components/PlayerContainer';
import RentalsBrowse from './RentalsBrowse';
import Page from './Page';
import TextPage from './TextPage';
import WatchTV from './WatchTV';
import Recordings from './Recordings';
import Downloads from './Downloads';
import ErrorPage from './InfoPage';
import AppEntry from './AppEntry';
import RecordingsDetails from './RecordingsDetails';
import AllRecordings from './Recordings/AllRecordings';
import Onboarding from './Onboarding/Onboarding';
import AppInfo from './AppInfo';
import ClearCache from './ClearCache';
import AccountInfo from './AccountInfo';
import QuickOnboardingInfoScene from './QuickOnboardingInfoScene';
import PackageInfoScene from './PackageInfoScene';
import VoyoUpsell from './VoyoUpsell';
import PreConsentScene from './PreConsentScene';
import VoyoPromoScene from './VoyoPromoScene';
import SuspendErrorScene from './SuspendErrorScene';
import ForceUpdate from './ForceUpdate';
import { ConsentsDetailed, ConsentsIntroPage } from './NativeConsents';
import ForgottenUsername from './ForgottenUsername';

export * from './Parental';
export * from './Settings';
export * from './Showtimes';
export * from './DeviceManagement';
export * from './NetworkSettings';
export * from './RecordPage';
export * from './LanguageSettings';
export * from './VideoQualitySettings';
export * from './ResetPin';
export * from './FavoriteSettings';

const availablePageNames = [
    'home',
    'details',
    'search',
    'settings',
    'player',
    'catalog',
    'watch-tv',
    'videostore',
    'my-content',
    'info-scene'
];

export {
    availablePageNames,
    ViewAll,
    Search,
    TvGuide,
    Login,
    Logout,
    Details,
    Register,
    Player,
    RentalsBrowse,
    Recordings,
    Page,
    TextPage,
    WatchTV,
    ErrorPage,
    AppEntry,
    RecordingsDetails,
    AllRecordings,
    Downloads,
    PasswordManagement,
    Filter,
    Onboarding,
    AppInfo,
    ClearCache,
    AccountInfo,
    QuickOnboardingInfoScene,
    PreConsentScene,
    VoyoPromoScene,
    PackageInfoScene,
    VoyoUpsell,
    SuspendErrorScene,
    ForceUpdate,
    ConsentsDetailed,
    ConsentsIntroPage,
    ForgottenUsername
};
